import React, { useEffect, useState } from 'react';
import classes from "./MyMatches2.module.css";
import { useNavigate } from 'react-router-dom';
import { userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import MatchLayoutForPrediction from '../../component/NewComponents/MatchLayoutForPrediction';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import Header2 from '../../component/NewComponents/Header2';
import { useTranslation } from 'react-i18next';

const MyMatches2 = () => {
    const navigate  = useNavigate();
    const dispatch  = useDispatch();
    const { userDetails } = useSelector(state => state.persisted?.userSlice);

    const [userMatches, setUserMatches] = useState(null);
    const [loader,      setLoader]      = useState(true);
    const [loading,     setLoading]     = useState(true);

    const {t}=useTranslation();

    const fetchUserMatches = async (load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await userMatchesApi(userDetails?.token);
            setUserMatches({ prediction: response?.data?.prediction });
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status === 403) {
                dispatch(removeUserDetails());
                toast.error(t("71"));
                navigate('/');
            } else {
                setLoader(false);
                setLoading(false);
                toast.error(
                    error?.response?.data?.message ||
                    error?.response?.message ||
                    error?.data?.message ||
                    t("2")
                );
            }
        }
    };

    useEffect(() => { fetchUserMatches(true); }, []);

    useEffect(() => {
        if (!loader) {
            const id = setInterval(() => {
                if (!document.hidden) fetchUserMatches(false);
            }, 10000);
            return () => clearInterval(id);
        }
    }, [loader]);

    const predictionList = userMatches?.prediction ?? [];

    return (
        <>
            <Header2 active={1} />

            <div className={classes.page}>
                <div className={classes.bgGlow} />
                <div className={classes.bgGrid} />

                <main className={classes.main}>

                    {/* ── Hero bar ── */}
                    <div className={classes.heroBar}>
                        <div className={classes.heroLeft}>
                            <span className={classes.heroEyebrow}>{t("128")}</span>
                            <h1 className={classes.heroTitle}>
                                {t("129")} <em>{t("130")}</em>
                            </h1>
                        </div>
                        {!loading && (
                            <div className={classes.heroBadge}>
                                <span className={classes.heroBadgeNum}>{predictionList.length}</span>
                                <span className={classes.heroBadgeLabel}>{t("131")}</span>
                            </div>
                        )}
                    </div>

                    <div className={classes.heroDivider} />

                    {/* ── Content ── */}
                    {loading ? (
                        <div className={classes.loaderWrap}>
                            <SmallLoader style={{ border: "4px solid #e60000", borderTopColor: "transparent" }} />
                            <p className={classes.loaderText}>{t("132")}</p>
                        </div>
                    ) : predictionList.length > 0 ? (
                        <div className={classes.matchGrid}>
                            {predictionList.map((match, index) => {
                                const match_details = match?.completed_match_details
                                    ? JSON.parse(match.completed_match_details)
                                    : match?.live_match_details
                                    ? JSON.parse(match.live_match_details)
                                    : null;

                                return (
                                    <MatchLayoutForPrediction
                                        key={index}
                                        match={match}
                                        match_details={match_details}
                                        index={index}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <div className={classes.emptyState}>
                            <span className={classes.emptyEmoji}>🎯</span>
                            <p className={classes.emptyTitle}>{t("133")}</p>
                            <p className={classes.emptySub}>
                                {t("134")}
                            </p>
                            <button
                                type="button"
                                className={classes.emptyBtn}
                                onClick={() => navigate('/home')}
                            >
                                {t("135")}
                            </button>
                        </div>
                    )}
                </main>
            </div>
        </>
    );
};

export default MyMatches2;